// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"508e2d9a","160":"e9858848","208":"87f193b5","293":"ecf09918","453":"acca0757","516":"234259ab","519":"e6ad261f","917":"8eba29b4","946":"16a207ad"}[chunkId] + ".chunk.js";
};